import PropTypes from 'prop-types';
import React from 'react';

export class NotificationMethodCheckbox extends React.Component {
  handleInputChange = (event) => {
    this.props.onChange(event.target.name, event.target.checked);
  }

  render = () => (
    <div className="checkbox">
      <label>
        <input type="checkbox" value="option1"
          aria-label={this.props.ariaCheckboxLabel}
          checked={this.props.isChecked}
          onChange={this.handleInputChange}
          name={this.props.name}
          disabled={this.props.isReadOnly !== undefined && this.props.isReadOnly}
        />
        {this.props.checkboxLabel}
      </label>
    </div>
  )
}

NotificationMethodCheckbox.propTypes = {
  ariaCheckboxLabel: PropTypes.string.isRequired,
  checkboxLabel: PropTypes.string.isRequired,
  isChecked: PropTypes.bool,
  onChange: PropTypes.func,
  name: PropTypes.string.isRequired,
  isReadOnly: PropTypes.bool,
};
